import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { LinterTabTitle } from '../components/cards/LinterTabTitle';

export const essityApiValidationReportModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    EntityContentBlueprint.make({
      name: 'validation-report',
      params: {
        path: '/linter',
        // Cast to bypass the string-only title type — the underlying Tab renders any ReactNode,
        // which lets the badge fetch and display this entity's live issue count.
        title: (<LinterTabTitle />) as unknown as string,
        filter: 'kind:api',
        loader: async () =>
          import('../components/cards').then(m => (
            <m.ApiValidationReportCard />
          )),
      },
    }),
  ],
});
